import { RequestService } from '../services/request.service';

export const unsubscribeWebPush = async (endpoint: string): Promise<void> => {
	const request = RequestService.getInstance();
	await request.post('/notify/v1/web-push/unsubscribe', { endpoint });
};
